import { startOfDay, subDays, subMonths } from 'date-fns'

/** Период в журнале событий — отдельный от глобального периода дашборда. */
export const EVENTS_PERIODS = ['all', 'today', 'week', 'month'] as const
export type EventsPeriod = (typeof EVENTS_PERIODS)[number]

export const EVENTS_PERIOD_LABELS: Record<EventsPeriod, string> = {
  all: 'За всё время',
  today: 'За сегодня',
  week: 'За неделю',
  month: 'За месяц',
}

export function getEventsPeriodFrom(
  period: EventsPeriod,
  now: Date = new Date(),
): string | undefined {
  switch (period) {
    case 'all':
      return undefined
    case 'today':
      return startOfDay(now).toISOString()
    case 'week':
      return subDays(now, 7).toISOString()
    case 'month':
      return subMonths(now, 1).toISOString()
  }
}
